import { ApiEndpointClient } from './resource-client';
const VALUATION_API_PREFIX = 'valuation-api/v1';
export class ReportCustomizationsClient extends ApiEndpointClient {
    http;
    constructor(http) {
        super(http, VALUATION_API_PREFIX);
        this.http = http;
    }
    getReportCustomization = async ({ valuationId }) => {
        return this.get(`/valuations/${valuationId}/report-customization`);
    };
    patchReportCustomization = async ({ valuationId, operations, }) => {
        return this.patch(`/valuations/${valuationId}/report-customization`, {
            json: operations,
        });
    };
}
